import styled from 'styled-components';
import { Wrapper } from '@service-victoria/component-library/components/Input/styled';
import colors from '@service-victoria/component-library/utils/colors';

export const InputWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  margin-top: 2px;
  margin-bottom: 2px;

  .PhoneInput {
    max-width: 350px;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .PhoneInputCountry {
    margin-right: 16px;
    padding: 0px 10px;
    border: 1px solid ${colors.blueGrey};
    border-radius: 2px;
    position: relative;
    align-items: center;
    align-self: stretch;
    display: flex;
  }

  .PhoneInputInput {
    width: 100%;
  }

  .PhoneInputCountrySelect {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    border: 0;
    opacity: 0;
    cursor: pointer;

    &,
    & > option {
      font-size: 16px;
    }
  }

  .PhoneInputCountryIcon {
    width: 56px;
    height: 22.6px;
  }

  .PhoneInputCountryIconImg {
    display: block;
    width: 100%;
    height: 100%;
  }

  .PhoneInputCountrySelectArrow {
    width: 100%;
    height: 42px;
    background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTMgOCI+CiAgICA8cGF0aCBmaWxsPSIjRTM3MTBBIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS4xMzIgMEw2LjUgNC4zMiAxLjg2OCAwIDAgMS44NjIgNi40NiA4IDEzIDEuODYyeiIvPgo8L3N2Zz4=)
      95% 55% no-repeat;
  }
`;
